import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { supabase } from '../lib/supabaseClient';
import { useAuthStore } from '../store/useAuthStore';
import { ticketKeys } from './queries/useTickets';

export function useTicketsRealtime() {
  const queryClient = useQueryClient();
  const collaborator = useAuthStore((s) => s.collaborator);
  const currentCollaboratorId = collaborator?.id;

  useEffect(() => {
    if (!currentCollaboratorId) return;

    const channel = supabase
      .channel('tickets-changes')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'tickets',
        },
        (payload) => {
          void queryClient.invalidateQueries({ queryKey: ticketKeys.all });

          const newRow = payload.new as Record<string, unknown> | undefined;

          // Toast pour les tickets INSERT (visibles à admin/secretary via RLS).
          if (payload.eventType === 'INSERT') {
            const senderName =
              typeof newRow?.sender_name === 'string' ? newRow.sender_name : 'Inconnu';
            toast(`Nouvelle demande reçue de ${senderName}`, {
              icon: '📬',
              duration: 4000,
            });
          }
        },
      )
      .subscribe();

    return () => {
      void supabase.removeChannel(channel);
    };
  }, [currentCollaboratorId, queryClient]);
}
